export default __webpack_public_path__ + "static/media/small-rock.876bf867.png";